import { useState, useEffect, useContext, useCallback } from 'react';
import UserContext from '../hooks/UserContext'
import Api from '../utils/Api';

const FETCH_INTERVAL = 30 * 1000;

const useNotifications = () => {
  const { user } = useContext(UserContext);
  const [notifications, setNotifications] = useState([]);
  const [count, setCount] = useState(0);

  const fetchNotifications = useCallback(async () => {
    if (user) {
      const [error, notifications] = await Api.getMyNotifications();
      if (error) console.error(error);
      else {
        setNotifications(notifications);
        setCount(notifications.length);
      }
    }
  }, [user]);

  const dismiss = useCallback(async (id) => {
    const [error,] = await Api.deleteNotification(id);
    if (error) console.error(error);
    else fetchNotifications();
  }, [fetchNotifications]);

  useEffect(() => {
    let timer = null;
    const startFetching = async () => {
      await fetchNotifications();
      timer = setTimeout(startFetching, FETCH_INTERVAL);
    };

    startFetching();
    return (() => clearTimeout(timer));

  }, [fetchNotifications]);

  return { notifications, count, dismiss };
}

export default useNotifications;